import React, { useState } from 'react';
import { back, chevron_right, gear } from '../../Images/Icons';
import { useNavigate } from 'react-router-dom';
import { View } from '../../Components';
import { useForm } from 'react-hook-form';
import {DoChangePassword} from '../../Services/AuthServices';
import css from './ChangePassword.module.scss';
const ChangePasswordPage = () => {
    const old_password_db = localStorage.getItem("password");

    const navigation = useNavigate();
    const {register, handleSubmit, setValue, watch, formState: { errors }, trigger} = useForm();
    const new_password = watch('new_password');
    const [state, setNewState] = useState({
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        visibleOldPassword: false,
        visibleNewPassword: false,
        visibleConfirmNewPassword: false,
    });

    const setState = data => {
        return setNewState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => {
        navigation(-1);
    }

    const onVisibleChange = index => () => {
        if (index == 0) {
            setState({ visibleOldPassword: !visibleOldPassword });
        } else if (index == 1) {
            setState({ visibleNewPassword: !visibleNewPassword });
        } else if (index == 2) {
            setState({ visibleConfirmNewPassword: !visibleConfirmNewPassword });
        }
    }
    
    const [showPopup, setShowPopup] = useState(false);

    function onUpdate(data) {
        DoChangePassword(data).then((result) => {
            setShowPopup(true)
        }).catch(({ response }) => {
            console.log(response)
        });
    }

    const { visibleOldPassword, visibleNewPassword, visibleConfirmNewPassword } = state;

    return (
        <div style={{}}>
            {showPopup && 
                <>
                    <div className={css.popup_wrap} onClick={() => navigation('/home')}>
                    <div className={css.content_popup}>          
                        <i class="fi fi-rr-cross-small" onClick={() => navigation('/home')}></i>
                        <img src="/monitoring/assets/success.png" />
                        <b>Successful!</b>
                        <p>The password update was successful! </p>
                    </div> 
                    </div>
                </>
            }
            <div class="mainHeader" style={{  display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Change Password</div>
                </div>
            </div>
            <form onSubmit={handleSubmit(onUpdate)}>
                <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: '#F2F5FA' }}>
                    <div style={{ margin: 20, marginTop: 24, padding: 18, background: 'white', borderRadius: 12 }}>
                        <div>
                            <div style={{ fontSize: 14, fontWeight: 500, color: '#292929' }}>Old Password</div>
                            <div className='form-control' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                <input name="old-password" type={visibleOldPassword ? "text" : "password"} placeholder='Enter Old Password' style={{ outline: 'none', fontSize: 14, border: 'none', padding: '6px 4px', marginRight: 10 }}
                                    {...register('old_password', {
                                        required: 'Old password is required',
                                        validate: value =>
                                          value === old_password_db || 'Sorry, your old password is incorrect. Please double check your password.'
                                    })}
                                    onBlur={() => trigger('old_password')}
                                />
                                <i onClick={onVisibleChange(0)} className={visibleOldPassword ? "fi fi-rr-eye" : "fi fi-rr-eye-crossed"} style={{ cursor: 'pointer' }}></i>
                            </div>
                            <div style={{ fontSize: 11, fontWeight: 400, color: 'red', marginTop: 8 }}>
                            {errors.old_password && <>{errors.old_password.message}</>}
                            </div>
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <div style={{ fontSize: 14, fontWeight: 500, color: '#292929' }}>New Password</div>
                            <div className='form-control' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                <input name="new-password" type={visibleNewPassword ? "text" : "password"} placeholder='Enter New Password'
                                    style={{ outline: 'none', fontSize: 14, border: 'none', padding: '6px 4px', marginRight: 10 }}
                                    
                                    {...register('new_password', {
                                      minLength: {
                                        value: 8,
                                        message: "Making sure it's at least 8 characters long."
                                      },
                                      validate: value =>
                                        value !== old_password_db || 'New password must be different from current password.',
                                      pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_)])[A-Za-z\d@$!%*?&_]{8,}$/,
                                        message: 'Password must contain mix of letters (both uppercase and lowercase), numbers, and special characters'
                                      },
                                      
                                    })}
                                    
                                    onBlur={() => trigger('new_password')}
                                    />
                                <i onClick={onVisibleChange(1)} className={visibleNewPassword ? "fi fi-rr-eye" : "fi fi-rr-eye-crossed"} style={{ cursor: 'pointer' }}></i>
                            </div>
                            <div style={{ fontSize: 11, fontWeight: 400, color: 'red', marginTop: 8 }}>
                                {errors.new_password && <p>{errors.new_password.message}</p>}
                            </div>
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <div style={{ fontSize: 14, fontWeight: 500, color: '#292929' }}>Confirm New Password</div>
                            <div className='form-control' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                <input name="confirm-new-password" type={visibleConfirmNewPassword ? "text" : "password"} placeholder='Enter Confirm Password'
                                    style={{ outline: 'none', fontSize: 14, border: 'none', padding: '6px 4px', marginRight: 10 }} 
                                    
                                    {...register('confirmNewPassword', {
                                        minLength: {
                                          value: 8,
                                          message: "Making sure it's at least 8 characters long."
                                        },
                                        validate: value =>
                                          value === new_password || 'Confirm your new password.',
                                        pattern: {
                                          value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_)])[A-Za-z\d@$!%*?&_]{8,}$/,
                                          message: 'Password must contain mix of letters (both uppercase and lowercase), numbers, and special characters'
                                        },
                                        
                                    })}
                                    onBlur={() => trigger('confirmNewPassword')}
                                />
                                <i onClick={onVisibleChange(2)} className={visibleConfirmNewPassword ? "fi fi-rr-eye" : "fi fi-rr-eye-crossed"} style={{ cursor: 'pointer' }}></i>
                            </div>
                            <div style={{ fontSize: 11, fontWeight: 400, color: 'red', marginTop: 8 }}>
                                {errors.confirmNewPassword && <p>{errors.confirmNewPassword.message}</p>}
                            </div>
                        </div>
                    </div>
                    <View >
                        <button style={{
                            width: '100%', height: 44, display: 'flex', justifyContent: 'center', marginLeft: 20, marginRight: 20,
                            fontSize: 16, fontWeight: 700, marginBottom: 40, background: '#2DFBB5',
                            alignItems: 'center', color: '#292929', borderRadius: 8, cursor: 'pointer', border:'none'
                        }}>
                            Submit
                        </button>
                    </View>
                </div>
            </form>
        </div>
    )
}

export default ChangePasswordPage